import { Bell, User, LogOut, Home, Bot, Activity, Settings, Compass, Rocket } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { cn } from '../utils/cn'

const navigation = [
  { name: 'Dashboard', href: '/', icon: Home },
  { name: 'Modèles d\'agents', href: '/agents', icon: Bot },
  { name: 'Modèles d\'équipes', href: '/teams', icon: Compass },
  { name: 'Déploiement', href: '/agents/deploy', icon: Rocket },
  { name: 'Surveillance', href: '/monitoring', icon: Activity },
]

export function Header() {
  const { user, logout } = useAuthStore()
  const location = useLocation()

  return (
    <header className="relative z-10 gradient-header">
      <div className="flex items-center justify-between px-8 py-5">
        <div className="flex items-center space-x-6">
          {/* Navigation horizontale - Onglets */}
          <nav className="flex items-end space-x-1 border-b border-white/20">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={cn('nav-tab', isActive && 'nav-tab--active')}
                >
                  <item.icon className="w-4 h-4" />
                  <span>{item.name}</span>
                </Link>
              )
            })}
            
            {/* Settings */}
            <Link
              to="/settings"
              className={cn('nav-tab', location.pathname === '/settings' && 'nav-tab--active')}
            >
              <Settings className="w-4 h-4 transition-transform hover:rotate-90" />
              <span>Paramètres</span>
            </Link>
          </nav>
        </div>
      </div>
    </header>
  )
}
